export const supports_PromoteEvents = [
	{
		icon: '🖼',
		title: 'supportData_title1',
		subtitle: 'supportData_subtitle1',
	},
	{
		icon: '⭐️',
		title: 'supportData_title2',
		subtitle: 'supportData_subtitle2',
	},
	{
		icon: '🎨',
		title: 'supportData_title3',
		subtitle: 'supportData_subtitle3',
	},
	{
		icon: '🔠',
		title: 'supportData_title4',
		subtitle: 'supportData_subtitle4',
	},
];
